// extracted by mini-css-extract-plugin
export var contactSection = "otActivitesHebergements-module--contactSection--a2c0b";
export var content = "otActivitesHebergements-module--content--36571";
export var description = "otActivitesHebergements-module--description--0becf";
export var grid = "otActivitesHebergements-module--grid--48368";
export var hidden = "otActivitesHebergements-module--hidden--739ee";
export var hide = "otActivitesHebergements-module--hide--7961b";
export var link = "otActivitesHebergements-module--link--f9e86";
export var reviews = "otActivitesHebergements-module--reviews--3f5ec";
export var svgWrapper = "otActivitesHebergements-module--svgWrapper--62589";
export var widget = "otActivitesHebergements-module--widget--1f1fa";
export var widgetWrapper = "otActivitesHebergements-module--widgetWrapper--8b46a";
export var wrapper = "otActivitesHebergements-module--wrapper--23bfe";